import { createSelector } from 'reselect';

export const getProduct = (state) => state.productData;

export const getBriefsSC = createSelector(
  getProduct,
  (productData) => productData.briefs
);

export const getBriefsLoadingSC = createSelector(
  getProduct,
  (productData) => productData.briefsLoading
);

export const getPluginInfo = createSelector(
  getProduct,
  (productData) => productData.pluginInfo
);
